export default __webpack_public_path__ + "static/media/404---no-bg 1.31385914.svg";